import React from 'react'
import MainPage from '../pages/MainPage'
import FeedPage from '../pages/FeedPage'

export enum PageCode {
  MAIN = 'main',
  FEED = 'feed',
}

export type RouteInfo = {
  name: PageCode
  component: React.FC | (() => JSX.Element)
}

const items: Array<RouteInfo> = [
  {
    name: PageCode.MAIN,
    component: MainPage,
  },
  {
    name: PageCode.FEED,
    component: FeedPage,
  },
]

export const activities = Object.fromEntries(
  items.map((item) => [item.name, item.component])
)

export const routes = Object.fromEntries(
  items.map((item) => [item.name, `/${item.name}`])
)

export type TypeActivities = typeof activities
